import { render, staticRenderFns } from "./zoomMinus.vue?vue&type=template&id=374a952f&"
import script from "./zoomMinus.vue?vue&type=script&lang=ts&"
export * from "./zoomMinus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports